import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';

const team = {
    crewList: [
        {
            crewItemImg: '',
            crewItemTitle: 'Иван Поддубный',
            crewItemSubtitle: 'CTO',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Василий Кульков',
            crewItemSubtitle: 'руководитель отдела менеджеров веб-проектов',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Александр Забанов',
            crewItemSubtitle: 'бэкенд-тимлид',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Павел Воробьев',
            crewItemSubtitle: 'старший фронтенд-разработчик',
        },
        {
            crewItemImg: '',
            crewItemTitle: '1 менеджер проекта',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '5 бэкенд-разработчиков',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '5 фронтенд-разработчиков',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '3 QA-инженера',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '2 контент-менеджера',
            crewItemSubtitle: '',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <div className="pochtabank-team">
                <FullWrapper>
                    <div className="pochtabank-team__Title">Команда</div>
                    <CrewContainer container={team} />
                </FullWrapper>
            </div>
        );
    }
}

export default Team;
